import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import {
  downloadConversationJson,
  downloadConversationMarkdown,
} from "util/exportChatConversation";
import styles from "./ExportChatModal.module.scss";

const isMacPlatform = () =>
  typeof navigator !== "undefined" &&
  /Mac|iPod|iPhone|iPad/.test(navigator.platform || "");

const ExportChatModal = ({
  open,
  onClose,
  conversationId,
  title,
  messages,
}) => {
  const backdropRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key !== "Escape") return;
      e.preventDefault();
      e.stopPropagation();
      onClose();
    };
    window.addEventListener("keydown", onKey, true);
    return () => window.removeEventListener("keydown", onKey, true);
  }, [open, onClose]);

  if (!open) return null;

  const exportPayload = { conversationId, title, messages };
  const shortcutLabel = isMacPlatform() ? "⌘⇧E" : "Ctrl⇧E";

  const handleBackdropClick = (e) => {
    if (e.target === backdropRef.current) onClose();
  };

  return createPortal(
    <div
      ref={backdropRef}
      className={styles.backdrop}
      onClick={handleBackdropClick}
      role="presentation"
    >
      <div
        className={styles.modal}
        role="dialog"
        aria-modal="true"
        aria-labelledby="export-chat-title"
      >
        <h2 id="export-chat-title" className={styles.title}>
          Export Conversation
        </h2>
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.btnPrimary}
            onClick={() => downloadConversationJson(exportPayload)}
          >
            Download as JSON
          </button>
          <button
            type="button"
            className={styles.btnOutline}
            onClick={() => downloadConversationMarkdown(exportPayload)}
          >
            Download as Markdown
          </button>
        </div>
        <p className={styles.hint}>Power user shortcut: {shortcutLabel}</p>
      </div>
    </div>,
    document.body
  );
};

export default ExportChatModal;
